module.exports = "---\nurl: \"http://petstore.swagger.io/v3/swagger.json\"\ndom_id: \"#swagger-ui\"\nfilter:\"\"\nvalidatorUrl: \"https://online.swagger.io/validator\"\noauth2RedirectUrl: \"http://localhost:3200/oauth2-redirect.html\"\n"


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 260
// module chunks = 0